export default __webpack_public_path__ + "static/media/join-avatar-2.67295513.png";